import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
import { PRICING_GRID } from '../feature-row/feature-row-skeleton';

/** Skeleton for the header row with plan columns */
function HeaderCatalogPlanSkeleton() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("grid", PRICING_GRID.responsive, "border-input h-21 items-center border-b");
    t1 = <div className="flex items-center px-6" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={t0}>{t1}<div className="flex h-full items-center justify-center lg:hidden"><div className="flex flex-col items-center gap-2"><div className="border-border size-4 shrink-0 rounded-full border" /><Skeleton className="bg-border h-3 w-16" /><Skeleton className="bg-border h-2.5 w-12" /></div></div>{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(_, i) {
  return <div key={i} className="hidden h-full min-w-0 items-center justify-center lg:flex"><div className="flex flex-col items-center gap-1"><div className="border-border size-4 shrink-0 rounded-full border" /><Skeleton className="bg-border h-3 w-16" /><Skeleton className="bg-border h-2.5 w-12" /></div></div>;
}
export { HeaderCatalogPlanSkeleton };